import React, { useContext, useEffect, useMemo, useState } from "react";
import { DarkModeContext } from "../../context/DarkModeContext";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Col, Form, Row, Spinner } from "react-bootstrap";
import logo from "../../assets/img/logo.png";
import TituloPagina from "../../components/comunes/TituloPagina";
import Footer from "../../components/comunes/Footer";
import BienvenidaMonitoreoOperativo from "../../components/PanelFlorenciaNuevo/BienvenidaMonitoreoOperativo";
import TablaComerciosRiesgo from "../../components/PanelFlorenciaNuevo/TablaComerciosRiesgo";
import "../../components/PanelFlorenciaNuevo/PanelMonitoreoOperativo.css";
import { getToken } from "../../utils/auth";


const ComerciosRiesgoOperativo = () => {
  const { darkMode } = useContext(DarkModeContext);
  const navegacion = useNavigate();
  const apiUrlToken = process.env.REACT_APP_API_TOKEN;
  const apiUrlProvincias = process.env.REACT_APP_API_PROVINCIAS;

  const [autorizado, setAutorizado] = useState(false);
  const [cargando, setCargando] = useState(false);
  const [provincias, setProvincias] = useState([]);
  const [provinciaSeleccionada, setProvinciaSeleccionada] = useState(null);
  const [fechaSeleccionada, setFechaSeleccionada] = useState(new Date());
  const [datos, setDatos] = useState(null);

  const filtrosClase = darkMode
    ? "monitoreo-operativo-filtros-dark"
    : "monitoreo-operativo-filtros";

  const formatFecha = (fecha) =>
    fecha
      ? fecha.toLocaleDateString("es-ES", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        })
      : "";

  const tokenSesion = useMemo(() => getToken(), []);

  useEffect(() => {
    const verificarToken = async () => {
      if (!tokenSesion) {
        manejarRespuestaNoAutorizada();
        return;
      }

      try {
        const response = await fetch(apiUrlToken, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ Token: tokenSesion }),
        });

        if (!response.ok) {
          manejarRespuestaNoAutorizada();
          return;
        }

        const data = await response.json();
        if (data !== 5) {
          manejarAccesoDenegado();
          return;
        }

        setAutorizado(true);
      } catch (error) {
        manejarRespuestaNoAutorizada();
      }
    };

    const redireccionar = () => {
      navegacion("/");
      window.location.reload();
    };

    const manejarRespuestaNoAutorizada = () => {
      sessionStorage.removeItem("token");
      Swal.fire({
        title: "Sesion expirada o token invalido.",
        text: "Inicie sesion nuevamente.",
        imageUrl: logo,
        imageWidth: 100,
        imageHeight: 30,
        imageAlt: "Logo",
        confirmButtonText: "Ok",
        timer: 5000,
        allowOutsideClick: true,
        customClass: {
          container: darkMode ? "swal2-container--dark" : "swal2-container--light",
          confirmButton: "my-swal-button",
        },
      }).then(redireccionar);
    };

    const manejarAccesoDenegado = () => {
      Swal.fire({
        title: "Acceso denegado.",
        text: "No tiene permisos para acceder.",
        imageUrl: logo,
        imageWidth: 100,
        imageHeight: 30,
        imageAlt: "Logo",
        confirmButtonText: "Ok",
        timer: 5000,
        allowOutsideClick: true,
        customClass: {
          container: darkMode ? "swal2-container--dark" : "swal2-container--light",
          confirmButton: "my-swal-button",
        },
      }).then(redireccionar);
    };

    verificarToken();
  }, [apiUrlToken, darkMode, navegacion, tokenSesion]);

  useEffect(() => {
    const fetchProvincias = async () => {
      try {
        const response = await fetch(apiUrlProvincias);
        if (!response.ok) {
          return;
        }

        const data = await response.json();
        setProvincias(
          data.map((item) => ({
            value: item.provincia,
            label: item.provincia,
          }))
        );
      } catch (error) {
        console.error("Error al obtener provincias", error);
      }
    };

    if (autorizado) {
      fetchProvincias();
    }
  }, [apiUrlProvincias, autorizado]);

  useEffect(() => {
    const fetchDatos = async () => {
      if (!autorizado || !tokenSesion) {
        return;
      }

      setCargando(true);
      try {
        const response = await fetch(process.env.REACT_APP_API_MONITOREO_COMERCIOS, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            Token: tokenSesion,
            Provincia: provinciaSeleccionada || "",
            Fecha: formatFecha(fechaSeleccionada),
          }),
        });

        if (response.ok) {
          setDatos(await response.json());
        } else {
          setDatos(null);
        }
      } catch (error) {
        console.error("Error al obtener comercios en riesgo", error);
        setDatos(null);
      }
      setCargando(false);
    };

    fetchDatos();
  }, [autorizado, fechaSeleccionada, provinciaSeleccionada, tokenSesion]);

  return (
    <div className="d-flex flex-column min-vh-100" translate="no">
      <div className="pt-5">
        <BienvenidaMonitoreoOperativo
          titulo="Panel Florencia"
          resumen={datos?.resumen}
        />
      </div>

      <section className="container pt-4 pb-3">
        <div className={`${filtrosClase} px-4 py-4`}>
          <Row className="align-items-end g-3">
            <Col lg={4} md={6}>
              <Form.Label className="fs-16 lato-bold mb-2">Filtrar por provincia</Form.Label>
              <Select
                classNamePrefix="select"
                options={provincias}
                onChange={(opcion) => setProvinciaSeleccionada(opcion ? opcion.value : null)}
                placeholder="Seleccione..."
                value={provincias.find((option) => option.value === provinciaSeleccionada) || null}
                isClearable
              />
            </Col>
            <Col lg={4} md={6}>
              <Form.Label className="fs-16 lato-bold mb-2">Seleccionar fecha</Form.Label>
              <DatePicker
                selected={fechaSeleccionada}
                onChange={setFechaSeleccionada}
                dateFormat="dd/MM/yyyy"
                className="form-control"
              />
            </Col>
            <Col lg={4} md={12}>
              <div className="d-flex align-items-center justify-content-lg-end h-100">
                <span className="lato-regular fs-14">
                  Fecha procesada: <span className="lato-bold">{datos?.fechaReferencia || formatFecha(fechaSeleccionada)}</span>
                </span>
              </div>
            </Col>
          </Row>
        </div>
      </section>

      <div>
        <TituloPagina title="Comercios en Riesgo" />
      </div>

      <div className="pb-4">
        {cargando ? (
          <div className="d-flex justify-content-center py-5">
            <Spinner animation="border" />
          </div>
        ) : (
          <TablaComerciosRiesgo data={datos} items={datos?.items || []} />
        )}
      </div>

      <div translate="no" className="py-4 mt-auto">
        <Footer />
      </div>
    </div>
  );
};

export default ComerciosRiesgoOperativo;
